import { Dialog, DialogActions, DialogContent, LinearProgress } from '@mui/material';
import React, { useState } from 'react'
import documentDataServices from '../documentDataServices';
import { useAlert } from '../../../../context/AlertContext';
import api from '../../../../api/api'
import { AttachFile } from '@mui/icons-material';


function DocumentAttachmentForm({documentId,onSuccess}) {
    const {AppAlert } = useAlert()
    const [dialogStatus,setDialogStatus] = useState("");
    const [savingInProgress,setSavingStatus] = useState("");
    const [uploadInProgress, setUploadProgress] = useState(null);

    const handleClose = () =>{
        setSelectedFile(null)
        setDialogStatus(false)
    }

    
    const [selectedFile,setSelectedFile] = useState(null)
    const selectFile = (e) =>{
        if(e.target.files[0].type !=='application/pdf'){
            AppAlert("Invalid File Type","error");
            return false;
        }
        setSelectedFile(e.target.files[0])
        
    }

    const uploadToServer = (formData) =>{
        api.post("document/data/attachment",formData,{
            onUploadProgress: (progressEvent) => { 
                const { loaded, total } = progressEvent;
                let percent = Math.floor((loaded * 100) / total);
                //console.log(percent);
                setUploadProgress(percent)
            },
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        }).then( (res)=>{
            AppAlert(res.data.msg)
            onSuccess();
        }).catch( (error) => {
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setUploadProgress(null)
            handleClose();
        })
      }

    const onSubmit = () => {
        let formData = new FormData();
        formData.append('documentId',documentId);
        formData.append('tmpFile', selectedFile);
        uploadToServer(formData);
    }

    return (
        <>
            <div className='btn btn-primary me-2' onClick={()=>setDialogStatus(true)} ><AttachFile /> Add Atachment</div>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='text-center'>
                                {selectedFile !== null && <embed className='img-fluid' style={{maxHeight:400}}  alt="preview file" src={URL.createObjectURL(selectedFile)} /> }
                            </div>
                        </div>
                    </div>
                    {selectedFile == null &&
                        <div class="d-flex justify-content-center">
                            <div className="form-group">
                                <input type="file"
                                    className='d-none'
                                    onChange={ (e)=>{ selectFile(e) } } 
                                    accept=".pdf, .txt, .doc, .docx"
                                    id="uploadDocumentAttachment" 
                                />
                                <label for="uploadDocumentAttachment" className='btn btn-primary'>Select File</label>
                            </div>
                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    {selectedFile!==null &&
                        <div className='row'>
                            <div className='col-md-12'>
                                {savingInProgress && <LinearProgress />}
                                {!savingInProgress &&
                                    <>
                                        <button className='btn btn-outline-primary me-2' onClick={handleClose} >Cancel</button>
                                        <button className='btn btn-primary' onClick={onSubmit}>Upload</button>
                                    </>
                                }
                            </div>
                        </div>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DocumentAttachmentForm